import { useContext } from "react";
import { ActivitiesContext } from "../context/activities-context";

const GetPrices = (props) => {
	const { dictionaryWords } = useContext(ActivitiesContext);

	return (
		<p>
			{props.priceInfo.name.nl && `${props.priceInfo.name.nl}: `}
			{props.priceInfo.price === 0 ? (
				<>
					<span>{dictionaryWords.free}</span>
				</>
			) : (
				<>
					<span>
						<i className="fa fa-eur" style={{ margin: 0 }}></i>
						{` ${props.priceInfo.price} euro`}
					</span>
				</>
			)}
		</p>
	);
};

export default GetPrices;
